import React from 'react';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import AttachmentsViewer from 'components/Utils/AttachmentsViewer';
import { DetailsPanelTopBar } from 'services/UIUtils';
import CalendarUtils from 'services/CalendarUtils';

const ImmunizationDetails = (props) => (
  <div className="details-panel padded-box new-immunization scroll-list">
    <DetailsPanelTopBar name="Immunization Details" onClose={props.onClose} />
    <div className="row form">
      <TextField name="name" label="Name" {...props} />
      <TextField name="route" label="Route" {...props} />
      <TextField name="dosage" label="Dosage" {...props} />
      <TextField name="lot" label="Lot #" {...props} />
      <TextField
        name="expiry_date"
        label="Expiry Date"
        value={getExpiryDate(props.immunization)}
        {...props}
      />
      <TextField
        name="given_date"
        label="Given Date"
        value={getGivenDate(props.immunization)}
        {...props}
      />
      <TextField name="given_by" label="Given By" {...props} />
    </div>
    {props.immunization.attachments !== undefined && (
      <AttachmentsViewer
        patient={props.patient}
        title={`Immunization: ${props.immunization.value.title}`}
        attachments={props.immunization.attachments}
      />
    )}
  </div>
);

const TextField = ({ name, label, width = 150, ...props }) => {
  return (
    <DefaultTextField
      name={name}
      disabled={props.inputDisabled}
      label={label}
      style={{ width: width + 'px', marginRight: '20px' }}
      value={props.immunization.value[name]}
      {...props}
    />
  );
};

function getGivenDate(immunization) {
  return immunization.value.given_date
    ? CalendarUtils.format(immunization.value.given_date)
    : undefined;
}

function getExpiryDate(immunization) {
  return immunization.value.expiry_date
    ? CalendarUtils.format(immunization.value.expiry_date)
    : undefined;
}

ImmunizationDetails.propTypes = {
  immunization: PropTypes.object.isRequired,
  inputDisabled: PropTypes.bool,
  onClose: PropTypes.func,
};

ImmunizationDetails.defaultProps = {
  inputDisabled: true,
};

export default ImmunizationDetails;
